/** @format */

import { useState } from 'react'
import { useGA4React } from 'ga-4-react'

const S_IDLE = 'idle'
const S_HOWTO = 'how-to-play'
const S_PLAY = 'playing'
const S_TIMEOUT = 'timeout'
const S_KO = 'finished'
const S_OK = 'submitted'

export function useGameState() {
  const [state, setState] = useState(S_IDLE)
  const ga = useGA4React()
  // const [state, setState] = useState(S_HOWTO)
  // const [state, setState] = useState(S_PLAY)
  // const [state, setState] = useState(S_KO)
  // const [state, setState] = useState(S_OK)
  // const [state, setState] = useState(S_TIMEOUT)

  return {
    //
    // state
    //

    state,

    //
    // derived
    //

    isStarted: state !== S_IDLE,
    isPlaying: state === S_PLAY,
    isHowToPlay: state === S_HOWTO,
    didFinish: state === S_KO,
    didSubmit: state === S_OK,
    isEnded: state === S_TIMEOUT,

    //
    // transitions
    //

    // idle -> playing
    startGameState: function() {
      if (state !== S_IDLE && state !== S_HOWTO) return // throw new Error('invalid transition')
      setState(S_PLAY)
      ga.event('game_started', 'Flavour Drop')
    },

    // idle -> how to play
    howToPlay: function() {
      if (state !== S_IDLE) return // throw new Error('invalid transition')
      setState(S_HOWTO)
      ga.event('how_to_play_click', 'Flavour Drop')
    },

    // playing -> ko
    timeout: function() {
      if (state !== S_PLAY) return // throw new Error('invalid transition')
      setState(S_TIMEOUT)
      ga.event('game_finished_timeout', 'Flavour Drop')
    },

    // playing -> ko
    finished: function() {
      if (state !== S_PLAY && state !== S_TIMEOUT) return // throw new Error('invalid transition')
      setState(S_KO)
      ga.event('game_finished_success', 'Flavour Drop')
    },

    // playing -> ok
    submitted: function() {
      if (state !== S_HOWTO && state !== S_KO && state !== S_OK) return // throw new Error('invalid transition')
      setState(S_OK)
    },

    // ko,ok,howto -> idle
    restart: function() {
      if (
        state !== S_HOWTO &&
        state !== S_KO &&
        state !== S_OK &&
        state !== S_TIMEOUT
      )
        return // throw new Error('invalid transition')
      setState(S_PLAY)
      ga.event('play_again_click', 'Flavour Drop')
    },
  }
}

export default useGameState
